import { render } from "./ImageSpinner.vue?vue&type=template&id=ccd7fb06&scoped=true"
const script = {}

import "./ImageSpinner.vue?vue&type=style&index=0&id=ccd7fb06&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd7fb06"]])

export default __exports__